export default __webpack_public_path__ + "static/media/oval2.9cf3fb7c.svg";